<template>
  <el-upload :list-type="listType" :action="upload_url" :headers="headers" :data="{f:method}" :on-success="handleSuccess" :before-upload="beforeAvatarUpload" v-bind="$attrs" v-on="$listeners">
    <slot></slot>
    <slot name="tips"></slot>
  </el-upload>
</template>

<script>
import Vue from "vue";
import store from "@/utils/store";
export default {
  name: "l-upload",
  props: {
    accept: {
      type: String,
      default: ".jpg,.png,.bmp",
    },
    method: {
      type: String,
      required: true,
    },
    beforeUpload: {
      type: Function,
      default: null,
    },
    onSuccess: {
      type: Function,
      required: true,
    },
    limitSize: {
      type: [String, Number],
      default: 150,
    },
    listType: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      upload_url: Vue.$_config.upload_url,
      headers: {
        AdminAuthorization: "Bearer " + store.get("token"),
      },
    };
  },

  methods: {
    handleSuccess(response, file, fileList) {
      if (response.status != 200) {
        this.$_msg.error(response.msg);
        return;
      }
      return this.$props.onSuccess(response, file, fileList);
    },

    beforeAvatarUpload(file) {
      // console.log(file);
      //检查文件大小限制
      if (this.$props.limitSize) {
        if (this.$props.limitSize * 1024 * 1024 < file.size) {
          this.$_msg.error("上传文件大小不能超过" + this.$props.limitSize + "M");
          return false;
        }
      }

      //检查后缀名
      let index = file.name.lastIndexOf(".");
      let ext = file.name.substr(index);
      if (!this.$props.accept.split(",").includes(ext.toLowerCase())) {
        this.$_msg.error("只允许上传以下类型的文件:" + this.$props.accept);
        return false;
      }

      this.loading = true;
      if (this.$props.beforeUpload !== null) {
        return this.$props.beforeUpload(file);
      } else {
        return true;
      }
    },
  },
};
</script>
